import i18n, { updateElementLocale } from "@/i18n";

const state = {
  // 当前语言，从 localStorage 读取，默认为简体中文
  currentLanguage: localStorage.getItem("language") || "zh-CN",
};

const mutations = {
  // 设置语言
  SET_LANGUAGE(state, language) {
    state.currentLanguage = language;
    // 将语言保存到 localStorage
    localStorage.setItem("language", language);
    // 同步更新 i18n 的语言设置
    i18n.locale = language;
    // 同步更新 ElementUI 的语言设置
    updateElementLocale(language);
  },
};

const actions = {
  // 切换语言
  setLanguage({ commit }, language) {
    commit("SET_LANGUAGE", language);
  },
};

const getters = {
  // 获取当前语言
  getCurrentLanguage: (state) => state.currentLanguage,

  // 获取语言显示文本
  getLanguageText: (state) => {
    const languageMap = {
      "zh-CN": "简",
      en: "En",
    };
    return languageMap[state.currentLanguage] || "简";
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
